import type { FeatureFlagsPluginOptions } from '@atlaskit/editor-plugin-feature-flags/featureFlagsPluginType';

interface Props {
	options: never;
}

export function featureFlagsPluginOptions({}: Props): FeatureFlagsPluginOptions {
	/**
	 * @private
	 * @deprecated Don't add any new feature flags here!
	 *             If you need a new feature flag, use:
	 *             - {@link editorExperiment} for new experiments.
	 *             - {@link fg} for new feature gates.
	 */
	return {
		lpLinkPicker: true,
		tableWithFixedColumnWidthsOption: true,

		tableSelector: true,
		macroInteractionUpdates: true,
		moreElementsInQuickInsertView: true,

		catchAllTracking: false,
		showAvatarGroupAsPlugin: false,
		errorBoundaryDocStructure: false,
		synchronyErrorDocStructure: false,
		enableViewUpdateSubscription: false,
		collabAvatarScroll: false,
		twoLineEditorToolbar: false,
		disableSpellcheckByBrowser: undefined,
	};
}
